export interface PerformanceKey {
  key: string;
  code?: string;
  repeat?: boolean;
  altKey?: boolean;
  ctrlKey?: boolean;
  metaKey?: boolean;
  shiftKey?: boolean;
  isComposing?: boolean;
}
export function performanceKey(event: PerformanceKey, editing = false): string | null {
  if (editing || event.repeat || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.isComposing) return null;
  const key = event.key.toLowerCase();
  return modeForPerformanceKey(key) !== null || ["r", "h", "f", " "].includes(key) ? key : null;
}

export function modeForPerformanceKey(key: string | null) {
  if (!key || !/^[1-4]$/.test(key)) return null;
  return REACTING_MODES[Number(key) - 1]?.id ?? null;
}

export function isEditingTarget(target: EventTarget | null): boolean {
  return target instanceof Element && !!target.closest("input, textarea, select, [contenteditable]:not([contenteditable='false'])");
}
import { REACTING_MODES } from "./lightFrameEngine";
